function _(t,n,r){var e=t(113),i=function(t){function n(n){return t.call(this,n)||this}return e.__extends(n,t),n}(t(166).Model);r.TickFormatter=i,i.__name__="TickFormatter"}
//# sourceMappingURL=tick_formatter.min.js.map